// Display only. Never pass these truncated strings to a transaction or MAX.
function parts(value) {
  if (!['number', 'string', 'bigint'].includes(typeof value)) return null;
  const match = String(value).trim().match(/^(\d+)(?:\.(\d*))?(?:e([+-]?\d+))?$/i);
  if (!match) return null;
  const exponent = Number(match[3] || 0);
  if (!Number.isSafeInteger(exponent) || Math.abs(exponent) > 1000) return null;
  const digits = match[1] + (match[2] || '');
  const point = match[1].length + exponent;
  const integer = (point <= 0 ? '0' : digits.slice(0, point).padEnd(point, '0')).replace(/^0+(?=\d)/, '');
  const fraction = (point < 0 ? '0'.repeat(-point) + digits : digits.slice(Math.max(0, point))).replace(/0+$/, '');
  return { integer, fraction };
}
const grouped = text => text.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
export function formatDisplay(value, decimals = 0) {
  const parsed = parts(value);
  if (!parsed) return '—';
  const { integer, fraction } = parsed;
  const tail = fraction.slice(0, decimals).padEnd(decimals, '0');
  if (integer === '0' && fraction && !/[1-9]/.test(tail))
    return decimals ? '<0.' + '0'.repeat(decimals - 1) + '1' : '<1';
  return grouped(integer) + (decimals ? '.' + tail : '');
}
// Full current read value, not a promise of full on-chain precision.
export function formatReadValue(value) {
  const parsed = parts(value);
  return parsed ? grouped(parsed.integer) + (parsed.fraction ? '.' + parsed.fraction : '') : '—';
}

export function dividendPool(staked, total) {
  const own = parts(staked), pool = parts(total);
  if (!own || !pool) return { state: 'unknown', share: null };
  const a = Number(staked), b = Number(total);
  if (!Number.isFinite(a) || !Number.isFinite(b) || a > b) return { state: 'unknown', share: null };
  return b === 0 ? { state: 'empty', share: 0 } : { state: 'ready', share: a / b * 100 };
}
